import React from "react";

export default function BsLayoutTextWindow() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd"
            d="M7.5 17.25C7.5 16.8358 7.83579 16.5 8.25 16.5H21.75C22.1642 16.5 22.5 16.8358 22.5 17.25C22.5 17.6642 22.1642 18 21.75 18H8.25C7.83579 18 7.5 17.6642 7.5 17.25Z" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M7.5 11.25C7.5 10.8358 7.83579 10.5 8.25 10.5H21.75C22.1642 10.5 22.5 10.8358 22.5 11.25C22.5 11.6642 22.1642 12 21.75 12H8.25C7.83579 12 7.5 11.6642 7.5 11.25Z" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M7.5 5.25C7.5 4.83579 7.83579 4.5 8.25 4.5H21.75C22.1642 4.5 22.5 4.83579 22.5 5.25C22.5 5.66421 22.1642 6 21.75 6H8.25C7.83579 6 7.5 5.66421 7.5 5.25Z" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M3 6.75C3.82843 6.75 4.5 6.07843 4.5 5.25C4.5 4.42157 3.82843 3.75 3 3.75C2.17157 3.75 1.5 4.42157 1.5 5.25C1.5 6.07843 2.17157 6.75 3 6.75Z" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M3 12.75C3.82843 12.75 4.5 12.0784 4.5 11.25C4.5 10.4216 3.82843 9.75 3 9.75C2.17157 9.75 1.5 10.4216 1.5 11.25C1.5 12.0784 2.17157 12.75 3 12.75Z" />
      <path fillRule="evenodd" clipRule="evenodd"
            d="M3 18.75C3.82843 18.75 4.5 18.0784 4.5 17.25C4.5 16.4216 3.82843 15.75 3 15.75C2.17157 15.75 1.5 16.4216 1.5 17.25C1.5 18.0784 2.17157 18.75 3 18.75Z" />

    </svg>
  );
}
